export const ORGS = 'ORGS';
export const GET_ORGS = 'GET/ORGS';
export const GET_ORGS_SUCCESS = 'GET/ORGS/SUCCESS';
export const GET_ORGS_FAILED = 'GET/ORGS/FAILED';
